/* eslint-disable react/no-unknown-property, react/style-prop-object */
import { h } from 'preact';
import SVGWrapper from '../../../../../../common/components/svg/SvgWrapper';

function PlaylistActiveIcon({ height = 60, width = 60, color = 'white', ...props }) {
  return (
    <SVGWrapper
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <g fill={color}>
        <path d="m12.0001 18c2.8415 0 5.6444.165 8.4.4852v1.3599c-2.7546-.3263-5.5576-.4951-8.4-.4951-2.84237 0-5.64542.1688-8.4.4951v-1.3599c2.75556-.3202 5.55853-.4852 8.4-.4852z" />
        <path d="m3.6001 9.03049c0-.52071.58636-.82996 1.02011-.54199.77147.51257 1.83795 1.2035 2.6795 1.6805.79753.452 1.86157.9781 2.69941 1.3793.51088.2446.49718.9924-.02226 1.2181-.83386.3623-1.88569.8355-2.67715 1.2469-.8477.4407-1.926 1.086-2.69942 1.5615-.43485.2674-1.00018-.0438-1.00019-.5543z" />
        <path d="m20.4001 15.075h-9v-1.35h9z" />
        <path d="m20.4001 10.275h-9v-1.34998h9z" />
        <path d="m20.4001 5.51487c-2.7556.32018-5.5585.48515-8.4.48515-2.84147 0-5.64444-.16497-8.4-.48515v-1.35996c2.75458.32633 5.55763.49511 8.4.49511 2.8424 0 5.6454-.16878 8.4-.49511z" />
      </g>
    </SVGWrapper>
  );
}

export default PlaylistActiveIcon;
